import { calculateColumnIndex } from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/components/ConversionSettingsForm/helpers/calculateColumnIndex';
import {
  COLUMN,
  FORMULA,
  NOT_PROVIDED,
  STATIC,
} from '@pages/Filing/ConversionTool/MappingSteps/CTStepOne/constants';

/**
 * @typedef {Object} ColumnMapping
 * @property {string} type - column mapping type
 * @property {string|number} value - column mapping value
 */

/**
 * @typedef {Object} SecondarySelection
 * @property {string} id - unique identifier
 * @property {string} displayValue - option type identifier
 */

/**
 * @typedef {Object} Selection
 * @property {string} display - display name
 * @property {string} optionType - option type identifier
 * @property {Array<string>} requires - required columns
 * @property {Array<SecondaryOption>} [options] - list of options
 */

/**
 * @typedef {Object} SelectedColumn
 * @property {string} id - unique identifier
 * @property {string} display - display name
 * @property {string} description - column description
 * @property {string} type - data type
 * @property {boolean} required - data type
 * @property {string} value - primary value
 * @property {string} optionalValue - optional value
 * @property {boolean} disabled - is field enabled
 * @property {boolean} selected - is field selected
 * @property {number|null} index - column index
 * @property {Array<Selection>} [options] - list of options
 */

/**
 * Transform for submission
 * @param {Object<string, SelectedColumn>} [selectedValues={}] - selected values in step 1
 * @returns {ColumnMapping|{}}
 */
export const conversionToolUpdateSelection = (selectedValues = {}) =>
  Object.values(selectedValues)
    .filter(item => item.value !== NOT_PROVIDED)
    .reduce((acc, curr) => {
      const isFormula = curr.value !== COLUMN && curr.value !== STATIC;
      const isColumn = curr.value === COLUMN;

      if (isColumn) {
        return {
          ...acc,
          [curr.id]: {
            type: COLUMN,
            value: calculateColumnIndex(curr.optionalValue),
          },
        };
      }

      if (isFormula) {
        return {
          ...acc,
          [curr.id]: {
            type: FORMULA,
            value: curr.value,
          },
        };
      }

      return {
        ...acc,
        [curr.id]: {
          type: curr.value,
          value: curr.optionalValue,
        },
      };
    }, {});
